import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TEACHER_REPORT_URL } from "../../api/URLs";
import { getDataRequest } from "../../api/serviceMethods";
import { BsArrowUpRightSquareFill } from "react-icons/bs";

const DashboardTeacherComponent = () => {
    const { t } = useTranslation();
    const [dashboardMemberData, setDashboardMemberData] = useState(null);
const getDashboard = async () => {
    try {
      const res = await getDataRequest(`${TEACHER_REPORT_URL}`);
      if (res.status === 200) {
        setDashboardMemberData(res.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  useEffect(() => {
    getDashboard();
  }, [])
    const dashboardData = [
        {
            title: t("Number of teachers"),
            total: dashboardMemberData && dashboardMemberData.teacherCount,
            rate: ""
        },
        {
            title: t("Number of courses"),
            total: dashboardMemberData && dashboardMemberData.courseCount,
            rate: ""
        },
        {
            title: t("Course purchase amount"),
            total: (
                <div>
                    <span>{dashboardMemberData && dashboardMemberData.purchaseAmounts}</span>
                    {/* <BsArrowUpRightSquareFill size={16} color="#45b887" style={{marginLeft:"0.5rem"}}/>
                    <span style={{fontSize:"1rem", color:"#636E88", marginLeft:"0.5rem"}}>{dashboardMemberData && dashboardMemberData.proRate + "%"}</span> */}
                </div>
            ),
            rate: ""
        }
    ]
    return (
        <Row >
            {
                dashboardData.map((item, ind) => (
                    <Col xs={24} sm={12} md={6} lg={6}>
                        <div className="d-flex" style={{ padding: "1.5rem 3rem", justifyContent: "space-between" }}>
                            <Row
                                className="text-center"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start"
                                }}
                            >
                                <Col className="titleCardNew14400">{item.title}</Col>
                                <Col className="totalCard28500">{item.total}</Col>
                            </Row>
                            {
                                item.title === "Course purchase amount" || item.title === "课程购买金额" ? "" :
                                    <div className="vr" style={{ height: "70px", borderLeft: "1px solid #000" }}></div>
                            }
                        </div>
                    </Col>
                ))
            }
        </Row>
    );
};

export default DashboardTeacherComponent;
